import styled, { css } from 'styled-components';

export const Loader = styled.div`
    display: block;
    width: 100%;
    margin-top:40px;
`;